const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export async function apiCall(method, path, body, token) {
  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    ...(body ? { body: JSON.stringify(body) } : {})
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Something went wrong');
  return data;
}

// Upload a single file as multipart/form-data. Don't set Content-Type — the
// browser adds it (with the multipart boundary) automatically for a FormData body.
export async function uploadFile(path, file, fieldName, token) {
  const form = new FormData();
  form.append(fieldName, file);

  const res = await fetch(`${BASE_URL}${path}`, {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: form
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Something went wrong');
  return data;
}

// Generation emits progress events while the server validates/retries the model.
export async function generateGrammarDrill(path, body, token, { onStatus, signal } = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    method: 'POST', signal,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error.error || 'Could not generate this round.');
  }
  const reader = res.body?.getReader();
  if (!reader) throw new Error('Could not read generation progress. Please try again.');
  const decoder = new TextDecoder();
  let buffer = '';
  let result;
  function handleLine(line) {
    if (!line.trim()) return;
    const event = JSON.parse(line);
    if (event.status === 'error') throw new Error(event.error || 'Could not generate this round.');
    if (event.status === 'ready') result = event;
    else onStatus?.(event);
  }
  try {
    while (true) {
      const { value, done } = await reader.read();
      buffer += done ? decoder.decode() : decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop();
      lines.forEach(handleLine);
      if (done) { handleLine(buffer); break; }
    }
  } finally {
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
  if (!result?.questions?.length) throw new Error('Generation ended before the questions were ready. Please try again.');
  return result;
}
